const getMetaTagData = (): { userId: string, token: string, [key: string]: any } => {
  let metaValues = null;
  const metas = Array.from(document.querySelectorAll("meta"));
  // reduce it down to an object, massaging any data as needed (e.g. string to int)
  metaValues = metas.reduce((out, m) => {
    if (m.name !== "") {
      out[m.name] = m.content;
    }
    return out;
  }, {});

  // Local development, override token and userId for mockdb/db.json usage
  if (process.env.NODE_ENV === "development") {
    // metaValues.userId = "dev_user_id";
    // metaValues.userId = "dev_user_sis_id";
    // metaValues.token = "dev_token";
  }

  // development environment variable setting
  return metaValues;
};

export default getMetaTagData;
